module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content index"
  }, [_c('div', {
    staticClass: "grid top-margin-8"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h1', {
    staticClass: "h-xl category",
    style: (_vm.textColor)
  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
    staticClass: "col-12 hero-row"
  }, [_c('div', {
    staticClass: "hero"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.heroImage,
      "alt": _vm.heroAlt
    }
  })])]), _c('div', {
    staticClass: "col-8_xs-12",
    attrs: {
      "data-push-left": "off-4_xs-0"
    }
  }, [_c('div', {
    staticClass: "copy wysiwyg",
    domProps: {
      "innerHTML": _vm._s(_vm.content.main_text)
    }
  }), _c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.children), function(child) {
    return _c('div', {
      staticClass: "col-6_xs-12"
    }, [_c('div', {
      staticClass: "page"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.route(child.uid)
      }
    }, [_c('div', {
      staticClass: "captions-mobile"
    }, [_c('h2', {
      staticClass: "subpage h-l"
    }, [_vm._v(_vm._s(child.content.title.toLowerCase()))])]), _c('div', {
      staticClass: "screen-smaller",
      style: (_vm.backgroundColor)
    }, [(_vm.pageHero(child.content.main_image, child.files)) ? _c('img', {
      staticClass: "cover",
      attrs: {
        "src": _vm.pageHero(child.content.main_image, child.files),
        "alt": child.content.title.toLowerCase()
      }
    }) : _vm._e(), (!_vm.pageHero(child.content.main_image, child.files)) ? _c('div', {
      staticClass: "imageless"
    }) : _vm._e(), _c('div', {
      staticClass: "captions",
      class: {
        gradient: _vm.pageHero(child.content.main_image, child.files)
      }
    }, [_c('h2', {
      staticClass: "subpage h-l"
    }, [_vm._v(_vm._s(child.content.title.toLowerCase()))])])])])], 1)])
  }))])])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c693340"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GenericIndex.vue
// module id = 240
// module chunks = 1